import React from 'react'
import FinancialVaultUploadTab from '../Upload/FinancialVaultUploadTab'

export default function FinancialVaultTaxInsurance() {
  return (
    <FinancialVaultUploadTab/>
  )
}
